/** Scroll to a message and flash it briefly. */
export function jumpToMessage(id: string) {
  const el = document.getElementById(`m-${id}`);
  if (!el) return;
  el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  el.classList.add('ring-2', 'ring-ink', 'ring-inset');
  setTimeout(() => el.classList.remove('ring-2', 'ring-ink', 'ring-inset'), 1800);
}
